module.exports = __webpack_public_path__ + "img/Picture1.f46fb446.png";